// we need to make sure we upload only one file at the time, otherwise CSRF token check fails
// limiting axios requests idea from https://gist.github.com/matthewsuan/2bdc9e7f459d5b073d58d1ebc0613169
import axios from 'axios'

const MAX_REQUESTS_COUNT = 1
const INTERVAL_MS = 100
let PENDING_REQUESTS = 0
const nonConcurrentUploadService = axios.create({
  baseURL: `${process.env.VUE_APP_E360_BASE_URL}${process.env.VUE_APP_E360_REST_URL}`,
})
nonConcurrentUploadService.interceptors.request.use(function intercept(config) {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
        PENDING_REQUESTS += 1
        clearInterval(interval)
        resolve(config)
      }
    }, INTERVAL_MS)
  })
})
nonConcurrentUploadService.interceptors.response.use(
  function resolve(response) {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.resolve(response)
  },
  function reject(error) {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.reject(error)
  },
)
export default {
  post(url, body = {}, options = { headers: {} }) {
    return nonConcurrentUploadService
      .post(url, body, options)
      .catch((error) => Promise.reject(error))
  },
}
